"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asTestableList = void 0;

var react_1 = __importStar(require("react"));

var lodash_1 = require("lodash");

var mobx_react_lite_1 = require("mobx-react-lite");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var model_1 = require("./model");

var NodeProvider = core_1.withNode(react_1.Fragment);

var ItemWithNode = function ItemWithNode(props) {
  var nodeKey = props.nodeKey,
      Component = props.component,
      rest = __rest(props, ["nodeKey", "component"]);

  return react_1.default.createElement(NodeProvider, {
    nodeKey: nodeKey
  }, react_1.default.createElement(Component, __assign({}, rest)));
};

var startComponents = {
  Wrapper: fclasses_1.asComponent('ul'),
  Item: fclasses_1.asComponent('li'),
  // For title we have to strip the props if not wrapped.
  Title: core_1.withOnlyProps('key', 'children')(react_1.Fragment),
  ItemMenuOptionsProvider: react_1.Fragment
};

var BasicList = function BasicList(_a) {
  var components = _a.components,
      unwrap = _a.unwrap,
      onDelete = _a.onDelete,
      rest = __rest(_a, ["components", "unwrap", "onDelete"]);

  var Wrapper = components.Wrapper,
      Item = components.Item,
      Title = components.Title;

  var _b = model_1.useItemsMutators({
    unwrap: unwrap,
    onDelete: onDelete
  }),
      _addItem = _b.addItem,
      _deleteItem = _b.deleteItem;

  var getItems = model_1.useItemsAccessors().getItems;
  var itemData = getItems();

  var canDelete = function canDelete() {
    return Boolean(getItems().length > 1 || unwrap);
  }; // Iterate over all items in the list creating list items.


  var items = itemData.map(function (item) {
    return react_1.default.createElement(ItemWithNode, {
      component: Item,
      key: item,
      nodeKey: item,
      addItem: function addItem() {
        return _addItem(item);
      },
      deleteItem: function deleteItem() {
        return _deleteItem(item);
      },
      canDelete: canDelete
    }, react_1.default.createElement(Title, null));
  });
  return react_1.default.createElement(Wrapper, __assign({}, rest), items);
};

var asTestableList = function asTestableList(listName) {
  return fclasses_1.withDesign({
    Wrapper: fclasses_1.addProps({
      'data-list-element': listName
    }),
    Title: fclasses_1.addProps({
      'data-list-element': 'title'
    }),
    Item: fclasses_1.addProps({
      'data-list-element': 'item'
    })
  });
};

exports.asTestableList = asTestableList;
/**
 * A List component.
 */

var List = lodash_1.flow(mobx_react_lite_1.observer, fclasses_1.designable(startComponents, 'List'), core_1.withNode)(BasicList);
List.displayName = 'List';
exports.default = List;